import React, { Component } from 'react';

import HomePage1 from '../../js/Components/home_page/HomePage';

class HomePage extends Component {
	render() {
		return <HomePage1 />;
	}
}

export default HomePage;
